import { render, staticRenderFns } from "./VirtupetIcon.vue?vue&type=template&id=076cd84e&scoped=true"
import script from "./VirtupetIcon.vue?vue&type=script&lang=js"
export * from "./VirtupetIcon.vue?vue&type=script&lang=js"
import style0 from "./VirtupetIcon.vue?vue&type=style&index=0&id=076cd84e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076cd84e",
  null
  
)

export default component.exports